import { useCallback } from 'react';
import { AxiosService } from 'src/axios/axios.service';

export type tSendReactionParams = {
  workspaceId: string;
  recipientPhone: string;
  messageId: string;
  emoji: string;
};

export default function useSendReaction() {
  const sendReaction = useCallback(
    async (params: tSendReactionParams) => {
      await AxiosService.post(
        `/whatsapp-api/workspaces/${params.workspaceId}/messages/reaction`,
        {
          to: params.recipientPhone,
          messageId: params.messageId,
          emoji: params.emoji,
        },
      );
    },
    [],
  );

  return { sendReaction };
}
